<template>
  <div class="section">
    <div class="container">
      <b-table :data="history"
               mobile-cards
               default-sort-direction="desc"
               default-sort="Date">
        <b-table-column field="Name" label="Product" sortable v-slot="props">
          {{props.row.Name}}
        </b-table-column>
        <b-table-column field="Date" label="Purchased On" sortable v-slot="props">
          {{props.row.Date | utc | moment('MM/DD/YYYY')}}
        </b-table-column>
        <b-table-column field="Link" label="Download" v-if="props.row.Link" v-slot="props">
          <a href="javascript://" @click="Download(props.row.Link)">Download</a>
        </b-table-column>
      </b-table>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        history: []
      }
    },
    methods: {
      Download(Link) {
        this.$http({ method: 'get', url: Link, responseType: 'arraybuffer' }).then(resp => {
          if (Link.indexOf("api/print/cft") >= 0) {
            let blob = new Blob([resp.data]);
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            var headers = resp.headers["content-disposition"];
            var filename = headers.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            filename = filename[0].replace("filename=", "").replace(/['"]/g, '');
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
          else if (Link.indexOf("api/group/annotations") >= 0) {
            this.$buefy.toast.open("An email was sent to you with the annotations attached.");
          }
        });
      },
      Refresh() {
        this.$http.get('api/purchase').then(resp => {
          this.history = resp.data;
        }).catch(err => {
          this.$buefy.notification.open({
            duration: 4000,
            message: "There was a problem loading your purchase history. Try refreshing the page.",
            type: 'is-danger',
            hasIcon: true
          });
        });
      }
    },
    created() {
      this.Refresh();
    }
  }
</script>
